<template>
  <IndexView />
  <div id="overlay" class="fixed inset-0 bg-black bg-opacity-30 z-30" :class="{ hidden: !isBlur }"></div>
  <ViewContainer>
    <section class="p-6">
      <PageTitle title="Cash Register" />
      <div class="bg-white dark:bg-dark-900 w-full rounded-lg py-6 px-5 shadow-lg">
        <div id="table-header" class="mb-5 justify-between items-end hidden">
          <div id="date-filter" class="flex relative">
            <div class="flex flex-col me-3">
              <label for="" class="text-gray-500 dark:text-gray-400 font-medium">Tanggal Mulai</label>
              <input type="date"
                class="mt-1 py-2 w-64 border border-gray-400 rounded-md px-3 text-gray-500 dark:text-gray-400 placeholder:text-gray-400 dark:placeholder:text-gray-500 sm:text-sm sm:leading-6 focus:outline-none focus:ring focus:ring-color-2 dark:bg-dark-800" />
            </div>
            <div class="flex flex-col me-3">
              <label for="" class="text-gray-500 dark:text-gray-400 font-medium">Tanggal Akhir</label>
              <input type="date"
                class="mt-1 py-2 w-64 border border-gray-400 rounded-md px-3 text-gray-500 dark:text-gray-400 placeholder:text-gray-400 dark:placeholder:text-gray-500 sm:text-sm sm:leading-6 focus:outline-none focus:ring focus:ring-color-2 dark:bg-dark-800" />
            </div>
            <div class="flex items-end">
              <SubmitButton button_name="Terapkan"
                button_class="hover:bg-color-2 bg-color-1 text-white border border-color-1" />
            </div>
          </div>
          <div class="w-[18rem]">
            <InputText placeholder="Cari ..." input_class="w-full" />
          </div>
        </div>
        <div class="overflow-x-auto">
          <div class="inline-block min-w-full align-middle">
            <div class="overflow-hidden shadow-lg rounded-lg">
              <TableComponent>
                <TableHead>
                  <TableRow>
                    <TableHeadCell>No</TableHeadCell>
                    <TableHeadCell>Start Time</TableHeadCell>
                    <!-- <TableHeadCell>Start Oleh</TableHeadCell> -->
                    <!-- <TableHeadCell>End Oleh</TableHeadCell> -->
                    <TableHeadCell>Saldo Awal</TableHeadCell>
                    <TableHeadCell>Total Transaksi Cash</TableHeadCell>
                    <TableHeadCell>Total Withdrawal</TableHeadCell>
                    <TableHeadCell>Total Deposit</TableHeadCell>
                    <TableHeadCell>Saldo Akhir</TableHeadCell>
                    <TableHeadCell>Selisih/Lebih</TableHeadCell>
                    <TableHeadCell>Close Time</TableHeadCell>
                    <TableHeadCell>Status</TableHeadCell>
                    <TableHeadCell>View</TableHeadCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  <TableRow v-if="allCashRegisters.length == 0">
                    <TableCell colspan="12" customClass="text-center italic text-gray-400 dark:text-gray-500"
                      noTextColor>
                      Belum ada data
                    </TableCell>
                  </TableRow>
                  <TableRow v-else v-for="(cashRegister, index) in allCashRegisters" :key="cashRegister.id"
                    :index="index" isBody>
                    <TableCell>{{ index + 1 }}</TableCell>
                    <TableCell>{{ formatTime(cashRegister.time_start) }}</TableCell>
                    <!-- <TableCell>{{ cashRegister.start_by }}</TableCell> -->
                    <!-- <TableCell>{{ cashRegister.end_by }}</TableCell> -->
                    <TableCell>{{ formatRupiah(cashRegister.start_saldo) }}</TableCell>
                    <TableCell>{{ formatRupiah(sumClosedTransaction(cashRegister)) }}</TableCell>
                    <TableCell>{{ formatRupiah(withdrawalPettyCash(cashRegister)) }}</TableCell>
                    <TableCell>{{ formatRupiah(depositPettyCash(cashRegister)) }}</TableCell>
                    <TableCell>{{ formatRupiah(cashRegister.end_saldo) }}</TableCell>
                    <TableCell>
                      <span v-if="difference(cashRegister) > 0" class="text-red-500">
                        {{ formatRupiah(difference(cashRegister)) }}
                      </span>
                      <span v-if="difference(cashRegister) < 0" class="text-yellow-500">
                        {{ formatRupiah(difference(cashRegister)) }}
                      </span>
                      <span v-if="difference(cashRegister) == 0" class="text-green-500">
                        Sesuai
                      </span>
                    </TableCell>
                    <TableCell>{{ formatTime(cashRegister.time_end) }}</TableCell>
                    <TableCell>
                      <span :class="{
                        'bg-green-100 dark:bg-green-900 text-green-800 dark:text-green-300': cashRegister.status === 'open',
                        'bg-red-100 dark:bg-red-900 text-red-800 dark:text-red-300': cashRegister.status === 'close'
                      }" class="px-2 py-1 rounded-full text-xs font-medium uppercase">
                        {{ cashRegister.status }}
                      </span>
                    </TableCell>
                    <TableCell>
                      <button :id="'view-order-' + cashRegister.id"
                        class="border border-gray-400 hover:border-green-700 hover:bg-green-400 flex justify-center items-center mx-1 p-2 rounded-md group"
                        @click="showOrder(cashRegister.id)">
                        <EyeIcon class="h-4 w-4 group-hover:text-green-700" />
                      </button>
                      <button :id="'view-order-' + cashRegister.id"
                        class="border border-gray-400 hover:border-green-700 hover:bg-green-400 flex justify-center items-center mx-1 p-2 rounded-md group"
                        @click="printReport(cashRegister.id)">
                        <PrinterIcon class="h-4 w-4 group-hover:text-green-700" />
                      </button>
                      <!-- <button :id="'test-payment-' + cashRegister.id"
                        class="border border-blue-400 hover:border-blue-700 hover:bg-blue-400 flex justify-center items-center mx-1 p-2 rounded-md group"
                        @click="printPaymentTypeOnly(cashRegister.id)"
                        title="Test Payment Type Summary">
                        <PrinterIcon class="h-4 w-4 text-blue-500 group-hover:text-blue-700" />
                      </button> -->
                    </TableCell>
                  </TableRow>
                </TableBody>
              </TableComponent>
              <PaginationButtons v-model="currentPage" :totalPages="totalPages" />
            </div>
          </div>
        </div>
      </div>
    </section>
  </ViewContainer>
</template>

<script>
  import IndexView from "@/views/IndexView.vue";
  import PageTitle from "@/components/PageTitle.vue";
  import ViewContainer from "@/components/ViewContainer.vue";
  import {
    TableComponent,
    TableHead,
    TableRow,
    TableHeadCell,
    TableBody,
    TableCell,
  } from "@/components/table";
  import { EyeIcon, PrinterIcon } from "@heroicons/vue/24/solid";
  import { formatRupiah } from "@/helpers/formatRupiah";
  import SubmitButton from "@/components/form/SubmitButton.vue";
  import InputText from "@/components/form/InputText.vue";
  import { formatDate, formatTime } from "@/helpers/formatTime";
  import { mapGetters } from "vuex";
  import PaginationButtons from "@/components/PaginationButtons.vue";
  import print from "@/helpers/print";
  import axios from "axios";
  import { calculateCashRegisterSummary } from "@/helpers/cashRegisterCalculations";

  export default {
    name: "ItemView",
    components: {
      IndexView,
      PageTitle,
      ViewContainer,
      TableComponent,
      TableHead,
      TableRow,
      TableHeadCell,
      TableBody,
      TableCell,
      EyeIcon,
      PrinterIcon,
      SubmitButton,
      InputText,
      PaginationButtons,
    },
    data() {
      return {
        isBlur: false,
        listCashRegister: [],
        showModal: false,
        selectedCashRegisterId: null,
        currentPage: 1,
        totalPages: 1,
        summaryCashRegister: {},
      };
    },
    computed: {
      ...mapGetters('cash_registers', ['allCashRegisters']),
      ...mapGetters('petty_cash', ['allPettyCashes']),
      ...mapGetters('item_categories', ['allItemCategories']),
      ...mapGetters('tables', ['allTables']),
      ...mapGetters('payment_methods', ['allPaymentMethods']),
      ...mapGetters("settings", ["allSettings"]),
      ...mapGetters("global_discounts", ["allGlobalDiscounts"]),
    },
    async created() {
      await this.fetchCashRegisters();
      await this.$store.dispatch('petty_cash/fetchPettyCashes');
      await this.$store.dispatch('item_categories/fetchItemCategories', { limit: 1000 });
      await this.$store.dispatch('tables/fetchTables', { limit: 1000 });
      await this.$store.dispatch('payment_methods/fetchPaymentMethods', { limit: 1000 });
      await this.$store.dispatch("settings/fetchSettings", { limit: 1000 });
      await this.$store.dispatch("global_discounts/fetchGlobalDiscounts", { limit: 1000 });
    },
    watch: {
      currentPage: {
        immediate: true,
        handler(newVal) {
          this.fetchCashRegisters({ page: newVal });
        },
      }
    },
    methods: {
      formatRupiah,
      formatTime,
      async fetchCashRegisters(params = {}) {
        if (!params.page) params.page = this.currentPage;
        if (!params.limit) params.limit = 50;
        try {
          const { pagination } = await this.$store.dispatch('cash_registers/fetchCashRegisters', params);
          if (pagination) {
            this.totalPages = pagination.totalPages;
          }
        } catch (error) {
          console.log(error);
        }
      },
      showOrder(id) {
        this.$router.push({ name: 'cashRegisterDetail', params: { id: id.toString() } });
      },
      closeModal() {
        this.showModal = false;
        this.selectedCashRegisterId = null;
      },
      sumClosedTransaction(cashRegister) {
        const orders = [...cashRegister.orders];

        // console.log(orders.filter(o => o.status == 'paid')
        // .filter(o => o.payment_method.is_cash_register).map(o => o.grand_total));

        return orders.filter(o => o.status == 'paid')
          .filter(o => o?.payment_method?.is_cash_register)
          .reduce(
            (sum, item) => {
              return sum + parseFloat(item.grand_total);
            },
            0
          )
      },
      withdrawalPettyCash(cashRegister) {
        return this.allPettyCashes.reduce((sum, item) => {
          return sum + (item.cash_register_id === cashRegister.id ? parseFloat(item.amount_withdrawal ? item.amount_withdrawal : 0) : 0);
        }, 0);
      },
      depositPettyCash(cashRegister) {
        return this.allPettyCashes.reduce((sum, item) => {
          return sum + (item.cash_register_id === cashRegister.id ? parseFloat(item.amount_deposit ? item.amount_deposit : 0) : 0);
        }, 0);
      },
      difference(cashRegister) {
        const sum = this.sumClosedTransaction(cashRegister) + this.depositPettyCash(cashRegister) - this.withdrawalPettyCash(cashRegister);

        return parseFloat(cashRegister.start_saldo) + sum - parseFloat(cashRegister.end_saldo == null ? 0 : cashRegister.end_saldo);
      },
      async setSummaryCashRegister(cashRegisterId) {
        try {
          const { data } = await this.$store.dispatch("reports/fetchCashRegisterReport", {
            cash_register_id: cashRegisterId,
          });
          const settings = this.allSettings.length > 0 ? this.allSettings[0] : {};

          this.summaryCashRegister = calculateCashRegisterSummary(
            data,
            this.allPaymentMethods,
            this.allItemCategories,
            this.allTables,
            settings,
            this.allGlobalDiscounts
          );
        } catch (error) {
          console.log(error);
        }
      },
      formatElementForPrinting(data) {
        let printText = "";
        const rows = [];

        // Add company header with center alignment
        rows.push("\x1b\x61\x01"); // Center alignment
        rows.push(process.env.VUE_APP_STORE_NAME);
        rows.push(process.env.VUE_APP_STORE_ADDRESS);
        rows.push(process.env.VUE_APP_STORE_PHONE);
        rows.push(print.breakLine(40, "-"));

        rows.push("\x1b\x61\x00"); // Left alignment
        rows.push("LAPORAN PENJUALAN HARIAN");
        rows.push(print.breakLine(40, " "));

        // Add transaction details
        rows.push(
          print.twoColumn(`Work Date:`, `${formatDate(data.time_start)} - ${formatDate(data.time_end)}`, 17, 6, 17)
        );

        rows.push(print.breakLine(40, " "));
        rows.push(
          print.twoColumn(
            `Item Sales:`,
            `${this.formatRupiah(data.revenue_item)}`,
            17, 6, 17
          )
        );
        rows.push(
          print.twoColumn(`Item Discount:`, `${data.item_discount > 0 ? '-' : ''}${this.formatRupiah(data.item_discount)}`, 17, 6, 17)
        );
        rows.push(
          print.alignText(`-------------`, "", 40, 'right')
        );
        rows.push(
          print.twoColumn(`Item Net Sales:`, `${this.formatRupiah(data.revenue_sales)}`, 17, 6, 17)
        );
        rows.push(
          print.twoColumn(`Bill Discount:`, `${data.bill_discount > 0 ? '-' : ''}${this.formatRupiah(data.bill_discount)}`, 17, 6, 17)
        );
        rows.push(
          print.alignText(`-------------`, "", 40, 'right')
        );
        rows.push(
          print.twoColumn(`Total Sales:`, `${this.formatRupiah(data.total_sales)}`, 17, 6, 17)
        );
        rows.push(
          print.twoColumn(`Total Service Charge:`, `${this.formatRupiah(data.total_service_charge)}`, 17, 6, 17)
        );
        rows.push(
          print.twoColumn(`Total Tax:`, `${this.formatRupiah(data.total_tax)}`, 17, 6, 17)
        );
        rows.push(
          print.alignText(`-------------`, "", 40, 'center')
        );
        rows.push(
          print.twoColumn(`Gross Sales:`, `${this.formatRupiah(data.revenue_net_sales)}`, 17, 6, 17)
        );

        rows.push(print.breakLine(40, " "));
        rows.push(
          print.twoColumn(`Total # of Item:`, `${data.total_item}`, 17, 6, 17)
        );
        rows.push(
          print.twoColumn(`Total # of of Bills:`, `${data.total_bill}`, 17, 6, 17)
        );
        rows.push(
          print.twoColumn(`Sales per Bill:`, `${this.formatRupiah(data.revenue_sales_per_bill)}`, 17, 6, 17)
        );

        rows.push(print.breakLine(40, " "));
        rows.push(
          print.twoColumn(`Total # of of Guests:`, `${data.total_bill}`, 17, 6, 17)
        );
        rows.push(
          print.twoColumn(`Sales per Guest:`, `${this.formatRupiah(data.revenue_sales_per_bill)}`, 17, 6, 17)
        );

        rows.push(print.breakLine(40, " "));
        rows.push(
          print.twoColumn(`Sales w/o SC:`, `${this.formatRupiah(data.revenue_sales_without_service_charge)}`, 17, 6, 17)
        );
        rows.push(
          print.twoColumn(`Sales w/o Tax:`, `${this.formatRupiah(data.revenue_sales_without_tax)}`, 17, 6, 17)
        );

        rows.push(print.breakLine(40, " "));
        rows.push(
          print.twoColumn(`Cancel With Order:`, `${data.total_qty_cancel_item}`, 17, 6, 17)
        );
        rows.push(
          print.twoColumn(`Total Amount:`, `${this.formatRupiah(data.revenue_cancel_item)}`, 17, 6, 17)
        );

        rows.push(print.breakLine(40, " "));
        rows.push(
          print.twoColumn(`Void # Payment:`, `${data.total_qty_void_sales}`, 17, 6, 17)
        );
        rows.push(
          print.twoColumn(`Void Amount:`, `${this.formatRupiah(data.revenue_void_sales)}`, 17, 6, 17)
        );

        // rows.push(print.breakLine(40, " "));
        // rows.push(`Jam Cetak: \t ${new Date().toLocaleString()}`);
        // rows.push("\n\n\n"); // Extra lines for paper cut
        // rows.push(print.breakLine(40, " "));
        // rows.push(print.breakLine(40, "="));
        // rows.push("\x1b\x61\x01"); // Center alignment
        // rows.push("Suspicious Transaction");
        // rows.push("\x1b\x61\x00"); // Left alignment
        // rows.push(print.breakLine(40, "="));

        // data?.sales_order_code?.forEach((code) => {
        //   rows.push(print.oneLine(code, 40));
        // });
        // rows.push(print.breakLine(40, "="));
        // rows.push(print.breakLine(40, " "));

        rows.push(print.breakLine(40, "="));
        rows.push("\x1b\x61\x01"); // Center alignment
        rows.push("Sales By Type");
        rows.push("\x1b\x61\x00"); // Left alignment
        rows.push(print.breakLine(40, "="));

        data?.sales_by_type?.forEach((type) => {
          rows.push(print.oneLine(`${type?.type}:`, 40));
          rows.push(print.twoColumn(`   QTY (${parseFloat(type?.qty / data?.total_item * 100).toFixed(2)}%) :`, `${type?.qty}`, 17, 6, 17));
          rows.push(print.twoColumn(`  Item Sales (${parseFloat(type?.revenue_item / data?.revenue_net_sales * 100).toFixed(2)}%) :`, `${this.formatRupiah(type?.revenue_item)}`, 17, 6, 17));
          rows.push(print.twoColumn(`  Discount Item :`, `${data.item_discount > 0 ? '-' : ''}${this.formatRupiah(type?.item_discount)}`, 17, 6, 17));
          rows.push(print.twoColumn(`  Discount Bill :`, `${data.bill_discount > 0 ? '-' : ''}${this.formatRupiah(type?.bill_discount)}`, 17, 6, 17));
          rows.push(print.oneLine(`------------------`, 40, `right`));
          rows.push(print.twoColumn(`  Item Net Sales (${parseFloat(type?.revenue_net_sales / data?.revenue_net_sales * 100).toFixed(2)}%) :`, `${this.formatRupiah(type?.revenue_net_sales)}`, 17, 6, 17));
        });
        rows.push(print.breakLine(40, " "));
        rows.push(print.breakLine(40, "-"));
        rows.push(print.twoColumn(`Total:`, `${this.formatRupiah(data?.total_sales_by_type)}`, 17, 6, 17));
        rows.push(print.breakLine(40, "="));

        rows.push(print.breakLine(40, "="));
        rows.push("\x1b\x61\x01"); // Center alignment
        rows.push("Sales By Category");
        rows.push("\x1b\x61\x00"); // Left alignment
        rows.push(print.breakLine(40, "="));

        data?.sales_by_category_item?.forEach((category) => {
          rows.push(print.oneLine(`${category?.category_name}:`, 40));
          rows.push(print.twoColumn(`   QTY (${parseFloat(category?.qty / data?.total_item * 100).toFixed(2)}%) :`, `${category?.qty}`, 17, 6, 17));
          rows.push(print.twoColumn(`  Item Sales (${parseFloat(category?.revenue_item / data?.revenue_net_sales * 100).toFixed(2)}%) :`, `${this.formatRupiah(category?.revenue_item)}`, 17, 6, 17));
          rows.push(print.twoColumn(`  Discount (${parseFloat(category?.bill_discount / data?.revenue_net_sales * 100).toFixed(2)}%) :`, `${data.bill_discount > 0 ? '-' : ''}${this.formatRupiah(category?.bill_discount)}`, 17, 6, 17));
          rows.push(print.twoColumn(`  Item Net Sales (${parseFloat(category?.revenue_net_sales / data?.revenue_net_sales * 100).toFixed(2)}%) :`, `${this.formatRupiah(category?.revenue_net_sales)}`, 17, 6, 17));
        });
        rows.push(print.breakLine(40, " "));
        rows.push(print.breakLine(40, "-"));
        rows.push(print.twoColumn(`Total:`, `${this.formatRupiah(data?.total_sales_by_category_item)}`, 17, 6, 17));
        rows.push(print.breakLine(40, "="));

        rows.push(print.breakLine(40, "="));
        rows.push("\x1b\x61\x01"); // Center alignment
        rows.push("Sales By Global Discount");
        rows.push("\x1b\x61\x00"); // Left alignment
        rows.push(print.breakLine(40, "="));

        data?.sales_by_global_discount?.forEach((discount) => {
          rows.push(print.oneLine(`${discount?.type}:`, 40));
          rows.push(print.twoColumn(`   QTY (${parseFloat(discount?.qty / data?.total_item * 100).toFixed(2)}%) :`, `${discount?.qty}`, 17, 6, 17));
          rows.push(print.twoColumn(`  Item Sales (${parseFloat(discount?.revenue_item / data?.revenue_net_sales * 100).toFixed(2)}%) :`, `${this.formatRupiah(discount?.revenue_item)}`, 17, 6, 17));
          rows.push(print.twoColumn(`  Discount Item :`, `${data.item_discount > 0 ? '-' : ''}${this.formatRupiah(discount?.item_discount)}`, 17, 6, 17));
          rows.push(print.twoColumn(`  Discount Bill :`, `${data.bill_discount > 0 ? '-' : ''}${this.formatRupiah(discount?.bill_discount)}`, 17, 6, 17));
          rows.push(print.oneLine(`------------------`, 40, `right`));
          rows.push(print.twoColumn(`  Item Net Sales (${parseFloat(discount?.revenue_net_sales / data?.revenue_sales * 100).toFixed(2)}%) :`, `${this.formatRupiah(discount?.revenue_net_sales)}`, 17, 6, 17));
        });
        rows.push(print.breakLine(40, " "));
        rows.push(print.breakLine(40, "-"));
        rows.push(print.twoColumn(`Total:`, `${this.formatRupiah(data?.total_sales_by_global_discount)}`, 17, 6, 17));
        rows.push(print.breakLine(40, "="));

        rows.push(print.breakLine(40, "="));
        rows.push("\x1b\x61\x01"); // Center alignment
        rows.push("Sales By Table/Room");
        rows.push("\x1b\x61\x00"); // Left alignment
        rows.push(print.breakLine(40, "="));

        data?.sales_by_table?.forEach((table) => {
          rows.push(print.twoColumn(`${table?.table_name}:`, `${this.formatRupiah(table?.revenue_net_sales)}`, 17, 6, 17));
        });
        rows.push(print.breakLine(40, " "));
        rows.push(print.breakLine(40, "-"));
        rows.push(print.twoColumn(`Total:`, `${this.formatRupiah(data?.total_sales_by_table)}`, 17, 6, 17));
        rows.push(print.breakLine(40, "="));

        rows.push(print.breakLine(40, "="));
        rows.push("\x1b\x61\x01"); // Center alignment
        rows.push("Payment Type Summary");
        rows.push("\x1b\x61\x00"); // Left alignment
        rows.push(print.breakLine(40, "="));

        data?.sales_by_payment_type?.filter((paymentType) => paymentType?.payment_method_name !== "Complimentary").forEach((paymentType) => {
          rows.push(print.twoColumn(`${paymentType?.payment_method_name}:`, `${this.formatRupiah(paymentType?.revenue_net_sales)}`, 17, 6, 17));
        });
        rows.push(print.breakLine(40, "-"));
        rows.push(print.twoColumn(`Total:`, `${this.formatRupiah(data?.total_sales_by_payment_type)}`, 17, 6, 17));
        rows.push(print.breakLine(40, "="));

        const complimentary = data?.sales_by_payment_type?.find((type) => type?.payment_method_name === "Complimentary");

        if (complimentary) {
          rows.push(print.breakLine(40, "="));
          rows.push(print.twoColumn(`Complimentary:`, `${this.formatRupiah(complimentary?.revenue_net_sales)}`, 17, 6, 17));
          rows.push(print.breakLine(40, "="));
        }

        rows.push(print.breakLine(40, "="));
        rows.push("\x1b\x61\x01"); // Center alignment
        rows.push("Pax By Table/Room Summary");
        rows.push("\x1b\x61\x00"); // Left alignment
        rows.push(print.breakLine(40, "="));

        data?.sales_by_table?.forEach((table) => {
          rows.push(print.twoColumn(`${table?.table_name}:`, `${table?.pax}`, 17, 6, 17));
        });
        rows.push(print.breakLine(40, " "));
        rows.push(print.breakLine(40, "-"));
        rows.push(print.twoColumn(`Total:`, `${data?.total_pax_by_floor}`, 17, 6, 17));
        rows.push(print.breakLine(40, "="));

        // Join all rows with newlines
        printText = rows.join("\n");

        return printText;
      },
      async printReport(cashRegisterId) {
        try {
          await this.setSummaryCashRegister(cashRegisterId);
          // Convert the element to text format suitable for ESC/POS
          const printText = this.formatElementForPrinting(this.summaryCashRegister);
          console.log("printText:", printText);
          console.log("cashRegisterId:", cashRegisterId);
          console.log("this.summaryCashRegister:", this.summaryCashRegister);

          // Send to backend printer endpoints
          const print_url =
            process.env.VUE_APP_ROOT_API + "/printer/printing/custom-print";

          const response = await axios.post(print_url, {
            text: printText,
            printer_ip: process.env.VUE_APP_CASIER_IP,
          });

          // Optional: Show success message
          console.log("Print job sent successfully", response);
        } catch (error) {
          console.error("Print error:", error);
          this.errorMessage = "Failed to print: " + error.message;
          this.showErrorDialog = true;
        }
      },
      async printPaymentTypeOnly(cashRegisterId) {
        try {
          await this.setSummaryCashRegister(cashRegisterId);
          
          // Create simplified print text with only Payment Type Summary
          const printText = this.formatPaymentTypeSummaryOnly(this.summaryCashRegister);
          console.log("Payment Type Summary printText:", printText);
          console.log("Payment data:", this.summaryCashRegister.sales_by_payment_type);

          // Send to backend printer endpoints
          const print_url = process.env.VUE_APP_ROOT_API + "/printer/printing/custom-print";

          const response = await axios.post(print_url, {
            text: printText,
            printer_ip: process.env.VUE_APP_CASIER_IP,
          });

          console.log("Payment Type Summary print job sent successfully", response);
        } catch (error) {
          console.error("Payment Type Summary print error:", error);
          this.errorMessage = "Failed to print Payment Type Summary: " + error.message;
          this.showErrorDialog = true;
        }
      },
      formatPaymentTypeSummaryOnly(data) {
        let printText = "";
        const rows = [];

        // Add company header with center alignment
        rows.push("\x1b\x61\x01"); // Center alignment
        rows.push(process.env.VUE_APP_STORE_NAME);
        rows.push(process.env.VUE_APP_STORE_ADDRESS);
        rows.push(process.env.VUE_APP_STORE_PHONE);
        rows.push(print.breakLine(40, "-"));

        rows.push("\x1b\x61\x00"); // Left alignment
        rows.push("TEST: PAYMENT TYPE SUMMARY");
        rows.push(print.breakLine(40, " "));

        // Add work date
        rows.push(
          print.twoColumn(`Work Date:`, `${formatDate(data.time_start)} - ${formatDate(data.time_end)}`, 17, 6, 17)
        );
        rows.push(print.breakLine(40, " "));

        // Payment Type Summary Section
        rows.push(print.breakLine(40, "="));
        rows.push("\x1b\x61\x01"); // Center alignment
        rows.push("Payment Type Summary");
        rows.push("\x1b\x61\x00"); // Left alignment
        rows.push(print.breakLine(40, "="));

        data?.sales_by_payment_type?.forEach((paymentType) => {
          rows.push(print.twoColumn(`${paymentType?.payment_method_name}:`, `${this.formatRupiah(paymentType?.revenue_net_sales)}`, 17, 6, 17));
        });
        rows.push(print.breakLine(40, " "));
        rows.push(print.breakLine(40, "-"));
        rows.push(print.twoColumn(`Total:`, `${this.formatRupiah(data?.total_sales_by_payment_type)}`, 17, 6, 17));
        rows.push(print.breakLine(40, "="));

        rows.push(print.breakLine(40, " "));
        rows.push(`Jam Cetak: \t ${new Date().toLocaleString()}`);
        rows.push("\n\n\n"); // Extra lines for paper cut

        // Join all rows with newlines
        printText = rows.join("\n\n\n");

        return printText;
      },
    },
  };
</script>